// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__K-1dS","title":"Info_title__XKaLF","links":"Info_links__28ZZh","link":"Info_link__1o-8x","logo":"Info_logo__rQ_XD"};